"use client";

import { GoogleAnalytics } from "@next/third-parties/google";
import { usePathname } from "next/navigation";
import { isEmbedWidgetPath } from "@/lib/embed-path";

const GA_ID = "G-N1P9MNQCEX";

/**
 * Google Analytics for every page except the embeddable widget, which runs inside
 * other people's sites and must not count as a visit here.
 *
 * Decided on the client from the pathname rather than in the server layout from a
 * request header: reading `headers()` in the root layout opts every route on the site
 * out of static generation, and the whole site was being server-rendered per request
 * because of it.
 */
export function SiteAnalytics() {
  const pathname = usePathname();
  if (pathname && isEmbedWidgetPath(pathname)) {
    return null;
  }
  return <GoogleAnalytics gaId={GA_ID} />;
}
